import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import nwApiSdk from '@lib/nw-api-sdk';

import rootReducers from './reducers';
import rootSaga from './sagas';
import { createAsyncMiddleware } from './middlewares/async';

export const makeStore = ({ apolloClient }) => {
  const sagaMiddleware = createSagaMiddleware();
  const asyncMiddleware = createAsyncMiddleware({
    IdentitySDK: nwApiSdk.IdentitySDK,
    identityApp: nwApiSdk.IdentitySDK.APPS.NERDWALLET_WEB,
    apolloClient,
  });

  const store = configureStore({
    reducer: rootReducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: false,
      }).concat([sagaMiddleware, asyncMiddleware]),
  });

  (store as any).sagaTask = sagaMiddleware.run(rootSaga);

  return store;
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
